import { AuditData } from "../../../../events/Setting/types"
import { EpicDependencies } from "../../../rxjs/configureEpics"
import { getAuthEmployeeId } from "../../employees/employees/selectors"
import { v7 as uuid7 } from "uuid"
import { useSelector } from "react-redux"

const getWebappPath = (): string | null => (typeof window !== "undefined" ? window.location.pathname : null)

export const constructAuditData = (deps: EpicDependencies, batched: boolean = false): AuditData => {
    const authEmployeeId = getAuthEmployeeId(deps.getState())

    return {
        // ip is added on manage-api (needs also setup for a specific event)
        ip: null,
        webappPath: getWebappPath(),
        editorUserAccountId: authEmployeeId ?? null,
        batchId: batched ? uuid7() : null,
    }
}

// Setting batch id here would be shared by every action until next render. IF something needs batch id, wrap it with `withBatchId`
export const useEventPayloadAuditData = (): AuditData => {
    const authEmployeeId = useSelector(getAuthEmployeeId)
    return {
        ip: null,
        webappPath: getWebappPath(),
        editorUserAccountId: authEmployeeId ?? null,
        batchId: null,
    }
}

// Copy of the audit data with a new batch ID. Call it once per user action so all events of that action share the ID.
export const withBatchId = (auditData: AuditData): AuditData => ({ ...auditData, batchId: uuid7() })
